import BatchPageHeaderHtml from "./BatchPageHeaderHtml.js";
import SignInSectionCmp from "../../../components/page-header/SignInSectionCmp.js";
import BreadcrumbsHeaderCmp from "../../../components/page-header/BreadcrumbsHeaderCmp.js";

export default class BatchPageHeaderCmp {
    #html = new BatchPageHeaderHtml();
    /** @type {SignInSectionCmp} */
    #singInSectionCmp = new SignInSectionCmp();
    /** @type {BreadcrumbsHeaderCmp} */
    #breadcrumbsCmp = new BreadcrumbsHeaderCmp();
    /** @type {UserHeaderCmp} */
    #userHeaderCmp;

    /** @param {UserHeaderCmp} userHeaderCmp */
    constructor(userHeaderCmp) {
        this.#userHeaderCmp = userHeaderCmp;
    }

    init(pageHeaderEl) {
        this.#html.init(pageHeaderEl);
        this.#singInSectionCmp.init(this.#html.getUserHeaderElement());
        this.#userHeaderCmp.init(this.#html.getUserHeaderElement());
        this.#breadcrumbsCmp.init(this.#html.getBreadcrumbsElement());
    }

    showReadOnlyModeIndicator() {
        this.#html.showReadOnlyChip();
    }

    /** @param {BatchMeta} batch */
    fillBreadcrumbs(batch){
        this.#breadcrumbsCmp.addBatchName(batch);
    }

    /**
     * @param {SecurityContext} securityContext
     */
    setSecurityContext(securityContext) {
        this.#singInSectionCmp.setSecurityContext(securityContext);
        if (securityContext.isAuthenticated())
            this.#userHeaderCmp.show(securityContext.getCurrentUser());
    }

    /** @param {function} callback */
    onShareBatchClick(callback) {
        this.#breadcrumbsCmp.onShareBatchClick(callback);
    }

    /** @param {function} callback */
    onDeleteBatchClick(callback) {
        this.#breadcrumbsCmp.onDeleteBatchClick(callback);
    }
}